<div class="container row">

  <app-config-line
    [title]="'Buscar configuración'"
    [description]="'Encuentra módulos o secciones usando palabras clave o nombres'"
    [withHr]="false"
  >
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input 
        type="text" 
        pInputText 
        [(ngModel)]="filterPanel" 
        placeholder="Escribe para buscar..." 
      />         
    </span>
  </app-config-line>


  <ng-container *ngFor="let option of panels; let i = index; trackBy: trackByKey">
    <app-config-line
      [title]="option.name"
      [description]="option.description"
      [filterBy]="filterPanel"
      *appHasPermission="option.permission"
    >    
      <!-- configuración adicional (vehículos) -->
      <button
        *ngIf="option.iconSection"
        type="button"
        class="btn btn-icon"
        (click)="openConfig(option.iconSection)"
        [pTooltip]="'Personalización de Íconos'"
      >
        <i class="pi pi-pencil"></i>
      </button>

      <!-- configuración drawer (new history) -->
      <!-- <ng-container *appHasPermission="'configuration_dinamic_history'">
        <button
          *ngIf="option.drawerNewHistory"
          type="button"
          class="btn btn-icon"
          (click)="openConfig(option.drawerNewHistory)"
          [pTooltip]="'Historial dinámico'"
        >
          <i class="pi pi-map"></i>
        </button>
      </ng-container> -->

      <!-- Botón de engranaje -->
      <button
        *ngIf="option.sectionConfig"
        type="button"
        class="btn btn-icon"
        (click)="openConfig(option.sectionConfig)"
        [pTooltip]="'Configuraciones'"
      >
        <i class="fa fa-cog"></i>
      </button>

      <!-- Switch -->
      <label class="custom-switch mb-0"
            [pTooltip]="'Ocultar o mostrar apartado'">
        <input
          type="checkbox"
          [(ngModel)]="option.enabled"
          (change)="updatePanelVisibility(option.key, option.enabled)"
        />
        <span class="slider"></span>
      </label>
    </app-config-line>
  </ng-container>
</div>
<ng-container *ngIf="filterPanel">
  <app-user-alert-config [filterOptionsBy]="filterPanel"></app-user-alert-config>
  <app-user-theme-config [filterOptionsBy]="filterPanel"></app-user-theme-config>
  <app-user-vehicle-config [filterOptionsBy]="filterPanel"></app-user-vehicle-config>
  <app-user-geofences-config [filterOptionsBy]="filterPanel"></app-user-geofences-config>
  <app-user-geopoints-config [filterOptionsBy]="filterPanel"></app-user-geopoints-config>
  <app-user-events-config [filterOptionsBy]="filterPanel"></app-user-events-config>
  <app-user-drivers-config [filterOptionsBy]="filterPanel"></app-user-drivers-config>
  <app-user-history-config [filterOptionsBy]="filterPanel"></app-user-history-config>
  <!-- <app-user-history-drawer *appHasPermission="'configuration_dinamic_history'" [filterOptionsBy]="filterPanel"></app-user-history-drawer> -->
</ng-container>
